import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {useGetSelfServiceFlowContactUs} from '../hooks/useGetSelfServiceFlow';
import {SelfServiceFlowFooterView} from './SelfServiceFlowFooterView';

export const SelfServiceFlowFooter = () => {
  return (
    <DataFetcher
      request={useGetSelfServiceFlowContactUs()}
      View={SelfServiceFlowFooterView}
      Error={() => null}
      Loading={() => null}
    />
  );
};
